import { LoadingOutlined } from "@ant-design/icons";
import { PaginationComponent } from "components";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogs } from "store/blogs/blogs.slice";

import { useLocation, useNavigate } from "react-router-dom";
import BlogItem from "./BlogItem";
import "./BlogPage.scss";

const BlogPage = () => {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { loading, list } = useSelector((store: any) => store.blogs);
  const dispatch: any = useDispatch();

  const getTitle = () => {
    let path = pathname.replace("/", "");
    let title = t("blog");
    switch (path) {
      case "our-projects":
        title = t("nasi_projekti");
        break;
      case "blogs":
        title = t("blog");
        break;
      case "partners":
        title = t("partneri");
        break;
    }
    return title;
  };
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(12);

  const changePageSize = (page: any, take: any) => {
    setCurrentPage(page);
    setPageSize(take);
  };
  useEffect(() => {
    changePageSize(1, 12);
  }, [pathname]);

  useEffect(() => {
    let path = pathname.replace("/", "");
    let postType = "";
    switch (path) {
      case "our-projects":
        postType = t("nasi_projekti");
        break;
      case "blogs":
        postType = "blog";
        break;
      case "partners":
        postType = "partneri";
        break;
    }

    dispatch(
      // TODO ORDER polje zakucano, trenutno nista
      fetchBlogs({
        page: currentPage,
        take: pageSize,
        order: "ASC",
        post_type: postType,
      }),
    );
  }, [dispatch, currentPage, pageSize, pathname]);

  return (
    <div className="Page">
      <div className="Page-Content">
        {loading === false ? (
          <>
            <h2 className="Page-Title">{getTitle()}</h2>

            {list.data.length !== 0 ? (
              <>
                <div className="Blog-Container">
                  {list.data.map((post: any, y: any) => (
                    <BlogItem post={post} pathname={pathname} key={y} />
                  ))}
                </div>
                <div>
                  <PaginationComponent
                    current={currentPage}
                    setCurrent={setCurrentPage}
                    totalItems={list.meta.item_count}
                    pageSize={pageSize}
                    changePageSize={changePageSize}
                  />
                </div>
              </>
            ) : (
              <label>Trenutno nema objava.</label>
            )}
          </>
        ) : (
          <LoadingOutlined />
        )}
      </div>
    </div>
  );
};
export default BlogPage;
